import { useObjectMemo } from "../../../../hooks";
import { useFeature } from "../../features";
import { PERMISSION, useBusinessPermissions } from "../../permissions";

const WIRE_PERMISSIONS = [
  PERMISSION.BUSINESS.WRITE.DOMESTIC_WIRE_TRANSACTION,
  PERMISSION.BUSINESS.WRITE.SWIFT_WIRE_TEMPLATE,
  PERMISSION.BUSINESS.WRITE.SWIFT_WIRE_VIA_TEMPLATE,
  PERMISSION.BUSINESS.WRITE.SWIFT_WIRE_TRANSACTION,
  PERMISSION.BUSINESS.WRITE.FEDWIRE_TEMPLATE,
  PERMISSION.BUSINESS.WRITE.FEDWIRE_VIA_TEMPLATE,
];

export const useWirePermissions = () => {
  const { featureEnabled, featureEquals } = useFeature();

  const showWireTransferOptionInMenu =
    featureEnabled({
      or: ["wires", "international_wires"],
    }) &&
    featureEnabled({
      or: [
        "indigo.WireTransaction_permission",
        "indigo.FedwireViaTemplate_permission",
        "indigo.SwiftWireTransaction_permission",
        "indigo.SwiftWireViaTemplate_permission",
      ],
    });
  const fedwireTemplatesEnabled = featureEquals("wire_templates", "fedwire");
  const internationalWires = featureEnabled("international_wires");
  const internationalWireTemplatesEnabled = featureEnabled({
    and: ["international_wires", "international_wire_templates"],
  });

  const [
    hasFedWireFreeformPermission,
    hasManageIntlWireTemplatesPermission,
    hasSendIntlWireViaTemplatesPermission,
    hasSendIntlWireFreeformPermission,
    hasFedwireTemplatePermission,
    hasFedwireViaTemplatePermission,
  ] = useBusinessPermissions(WIRE_PERMISSIONS);

  const showManageTemplatesUI =
    fedwireTemplatesEnabled && hasFedwireTemplatePermission;

  const showManageIntlWireTemplatesUI =
    internationalWireTemplatesEnabled && hasManageIntlWireTemplatesPermission;

  const canSendInternationalWire =
    hasSendIntlWireFreeformPermission ||
    (internationalWireTemplatesEnabled &&
      hasSendIntlWireViaTemplatesPermission);
  const canSendDomesticWire =
    hasFedWireFreeformPermission || hasFedwireViaTemplatePermission;

  return useObjectMemo({
    showWireTransferOptionInMenu,
    fedwireTemplatesEnabled,
    showManageTemplatesUI,
    internationalWires,
    internationalWireTemplatesEnabled,
    showManageIntlWireTemplatesUI,
    canSendInternationalWire,
    canSendDomesticWire,
    hasManageIntlWireTemplatesPermission,
    hasSendIntlWireViaTemplatesPermission,
    hasSendIntlWireFreeformPermission,
    hasFedWireFreeformPermission,
    hasFedwireTemplatePermission,
    hasFedwireViaTemplatePermission,
  });
};
